<template>
  <a-carousel :autoplay="true" style="width: 100%">
    <div v-for="(v, index) in cmsConfig.banner" :key="index" class="img"
    :style="{'height':'70px', 'background': 'url(' + v.imgUrl + ') no-repeat center/cover' }"
    @click="goToLink(v)">
    </div>
  </a-carousel>
</template>

<script>
import { Carousel } from 'ant-design-vue'
import { mapState } from 'vuex'
export default {
  components: {
    [Carousel.name]: Carousel
  },
  computed:{
    ...mapState(['cmsConfig'])
  },
  methods: {
    goToLink(v) {
      if (!v.linkUrl) return
      window.open(v.linkUrl)
    }
  }
}
</script>

